import type { Auth } from "firebase/auth";
import { firebaseConfig } from "./firebaseClient";

let authPromise: Promise<Auth> | null = null;

/**
 * Firebase Auth, loaded on demand. `firebase/auth` is a large chunk, so it is only ever
 * imported when a visitor actually logs in or already has a saved session (see entryGate's
 * auth hint) — never for a first-time visitor just browsing.
 */
export function getFirebaseAuth(): Promise<Auth> {
  authPromise ??= (async () => {
    const [{ getApps, initializeApp }, { getAuth, connectAuthEmulator }] = await Promise.all([
      import("firebase/app"),
      import("firebase/auth"),
    ]);
    const app = getApps()[0] ?? initializeApp(firebaseConfig);
    const auth = getAuth(app);
    const emulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
    // Dev builds only: a production bundle must never be able to talk to an emulator.
    if (import.meta.env.DEV && emulatorHost) {
      connectAuthEmulator(auth, `http://${emulatorHost}`, { disableWarnings: true });
    }
    return auth;
  })();
  return authPromise;
}
